const firebaseConfig = {
  apiKey: 'AIzaSyAhYxYM-ZUWgfHSYyqNgy1Hge9njjv4sZo',
  authDomain: 'delicious-resturant.firebaseapp.com',
  projectId: 'delicious-resturant',
  storageBucket: 'delicious-resturant.appspot.com',
  messagingSenderId: '176774236113',
  appId: '1:176774236113:web:fa525144badef014ddc2f0',
};

export default firebaseConfig;
